import React from "react"
import ContactUsSection from "./ContactUsSection"
import BubblesBg from "./BubblesBg/BubblesBg"

function ContactsPage() {
  return (
    <div>
      <ContactUsSection />
      <BubblesBg variant="variant2" />
    </div>
  )
}

export default ContactsPage